import { AssignmentTypeEnum, BookedToChangeReasonEnum } from 'api/model';

/**
 * Orsakerna till en ny bokad till-tid, grupperade efter vem som orsakade flytten — samma
 * gruppering som ledningsrapporten redovisar. Beslutad lista 2026-10-02.
 */
export const BOOKED_TO_CHANGE_REASON_GROUPS: {
  label: string;
  reasons: { value: BookedToChangeReasonEnum; label: string }[];
}[] = [
  {
    label: 'Kund',
    reasons: [
      {
        value: BookedToChangeReasonEnum.CustomerRequest,
        label: 'Kundens önskemål',
      },
    ],
  },
  {
    label: 'Riddermark',
    reasons: [
      { value: BookedToChangeReasonEnum.ChangedInRide, label: 'Ändrad i Ride' },
      { value: BookedToChangeReasonEnum.CarNotReady, label: 'Bilen inte klar' },
    ],
  },
  {
    label: 'Zäkra',
    reasons: [
      {
        value: BookedToChangeReasonEnum.NoFieldTesterAvailable,
        label: 'Ingen fälttestare tillgänglig',
      },
      {
        value: BookedToChangeReasonEnum.PlanningCoordination,
        label: 'Planering / samordning',
      },
    ],
  },
  {
    label: 'Övrigt',
    reasons: [
      {
        value: BookedToChangeReasonEnum.CorrectionOfWrongTime,
        label: 'Rättning av felinlagd tid',
      },
      {
        value: BookedToChangeReasonEnum.Other,
        label: 'Annat (kommentar krävs)',
      },
    ],
  },
];

export const bookedToChangeReasonRequiresComment = (
  reason: string | number | undefined
) =>
  reason !== undefined &&
  reason !== '' &&
  Number(reason) === BookedToChangeReasonEnum.Other;

/**
 * Bara huvuduppdraget kräver orsak: Normal, eller WithTest som inköp/inbyte/auktion får från Ride.
 * Vidaretransporter och resor flyttas många gånger om dagen och orsaken säger inget om
 * kundbokningen. Samma regel som CaseLogic.RecordBookedToChange.
 */
export const bookedToChangeReasonRequired = (
  assignmentType: string | number | undefined
) =>
  Number(assignmentType) === AssignmentTypeEnum.Normal ||
  Number(assignmentType) === AssignmentTypeEnum.WithTest;
